import styled from 'styled-components';

export const STDPage = styled.div`
  display: block;
  flex-wrap: unset;
  margin: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-right: var(--size-grid002);
  padding-left: var(--size-grid002);
`;
export const BoxFooter = styled.div`
  flex-shrink: 0;
  max-width: 100%;
  margin: 0px;
`;
export const DivFooter = styled.div`
  /* border-top: 2px solid rgb(0, 30, 80); */
  padding: 44px 0px;

  @media (min-width: 560px) {
    padding-top: 72px;
    padding-left: var(--size-grid001);
    padding-right: var(--size-grid001);
  }
`;
export const StdLine = styled.div`
  border-top: 1px solid rgb(223, 228, 232);
  text-align: left;
  width: var(--size-grid010);
  margin-top: 44px;

  @media (min-width: 560px) {
    margin-top: 64px;
    width: var(--size-grid005);
  }
`;

export const StdText = styled.div`
  color: rgb(0, 14, 38);
  margin: unset;
  font-family: var(--font-family-text);
  font-weight: normal;
  font-size: 0.88rem;
  line-height: 150%;
  letter-spacing: calc(-0.02em + 0.02rem);
`;
